import React from 'react'
import ProjectX from './ProjectX'
import Card from 'react-bootstrap/Card';
import picture from'../assets/illustration-hero.svg'
import '../styles/Home.css'


const Home = () => {
  return (
    <div>
        <ProjectX/>
    </div>
  )
}

export default Home